<template>
  <span class="d-icon" @click="$emit('click')">
    <font-awesome-icon :icon="[pack, icon]" :size="size" :class="[customClass]" :flip="flip" :rotation="rotation" :spin="spin" />
  </span>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
  import { library } from '@fortawesome/fontawesome-svg-core';
  import { fas } from '@fortawesome/free-solid-svg-icons';
  import { far } from '@fortawesome/free-regular-svg-icons';
  import { defineComponent } from 'vue';
  library.add(fas, far);

  export default defineComponent({
    name: 'DIcon',
    emits: ['click'],
    components: {
      FontAwesomeIcon,
    },

    props: {
      /**
       * FontAwesome approved packs
       * @parameters fas, far
       */
      pack: {
        type: String,
        default: 'fas',
      },
      customClass: [String, Array],

      /**
       * Flip the icon without animation
       * @parameters horizontal, vertical, both
       */
      flip: {
        type: String,
        default: null,
        validator: (value) => ['horizontal', 'vertical', 'both'].indexOf(value) > -1,
      },

      /**
       * Spin the icon using the Font Awesome speed rotation
       */
      spin: {
        type: Boolean,
        default: false,
      },

      /**
       * Rotate the icon
       * @parameters 90, 180, 270
       */
      rotation: {
        type: [String, Number],
        default: null,
        validator: (value) => [90, 180, 270].indexOf(parseInt(value, 10)) > -1,
      },

      /**
       * Select the icon
       */
      icon: {
        type: String,
        required: true,
      },

      /**
       * FontAwesome approved font sizes only
       * @parameters lg, xs, sm, 1x, 2x, 3x, 4x, 5x, 6x, 7x, 8x, 9x, 10x
       */
      size: {
        type: String,
        default: '1x',
        validator: (value) => ['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x'].indexOf(value) > -1,
      },
    },
  });
</script>